



























import Vue, { PropType } from "vue";
import OverallTrendsChart from "@/features/home/components/overallTrendsChart.vue";
import { OverallTrendsMaxAndMin } from "@/features/home/types";
import NoData from "@/features/home/components/noData.vue";

export default Vue.extend({
  components: {
    "overall-trends-chart": OverallTrendsChart,
    "no-data": NoData,
  },
  props: {
    loading: { type: Boolean, required: true },
    isNoData: { type: Boolean, required: true },
    hasMissingData: { type: Boolean, required: true },
    chartData: {
      type: Object as PropType<{ labels: string[]; revenue: number[]; impression: number[] }>,
      required: true,
    },
    chartDataMaxAndMin: {
      type: Object as PropType<OverallTrendsMaxAndMin>,
      required: true,
    },
  },
});
